import { LambdaAdmin } from "../../common/services/http-service"

const useUnificar = () => {

    const getCURPUnificar = async (EmpNumero, ClienteID) => {
        try {
            return await LambdaAdmin({ resource: `soporte/unificados?EmpNumero=${EmpNumero}&ClienteID=${ClienteID}`, method: "GET" });
        } catch (error) {
            const data = error.response?.data?.data;

            if (data === null) {
                return { exitoso: false, data: data }
            }

            const allMessages = [
                ...data.detalle.internos.flatMap(i => i.mensajes.map(m => m.descripcion)),
                ...data.detalle.errores.flatMap(e => e.mensajes.map(m => m.descripcion)),
                ...data.detalle.advertencias.flatMap(a => a.mensajes.map(m => m.descripcion)),
                ...data.detalle.informativos.flatMap(i => i.mensajes.map(m => m.descripcion)),
                ...data.detalle.exitosos.flatMap(e => e.mensajes.map(m => m.descripcion))
              ].join(" ");
            
            return { exitoso: false, data: allMessages }
        }
    };

    const putCURPUnificar = async (body) => {
        try {
            return await LambdaAdmin({ resource: `soporte/unificados`, method: "PUT", data: body });
        } catch (error) {
            const data = error.response?.data?.data;

            if (data) {
                return { exitoso: false, data: data }
            }
            
            return { exitoso: false, data: 'Hubo un error inesperado y no logramos unificar los datos. Espera unos minutos y prueba nuevamente.' };
        }
    };

    return {
        getCURPUnificar,
        putCURPUnificar
    };
};

export default useUnificar;